module.exports = __webpack_public_path__ + "static/img/15.a6fe132.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/2/15.png
// module id = 6Tfr
// module chunks = 0